import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface AmDashboard {
  stations: { active: number };
  rent: { pending: number; overdue: number; collectedThisMonth: number; overdueAmount: number };
  electricity: { pending: number; overdue: number; paidThisMonth: number; paidAmountThisMonth: number };
  agreements: { active: number; expiringSoon: number; renewed: number };
  discom: { open: number; resolved: number };
  urgent: Array<{ type: string; id: number; station: string | null; amount?: number; ref?: string; date: string | null; status: string }>;
}

export interface AmMonthlyPoint { month: string; collected: number; count: number }

export interface AmDeepAnalytics {
  stationsByProperty: Array<{ type: string; count: number }>;
  ownerTypeMix: Array<{ type: string; count: number }>;
  connections: { byType: Array<{ type: string; count: number }>; byDiscom: Array<{ discom: string; count: number }> };
  chargers: { total: number; totalCapacityKw: number; byType: Array<{ type: string; count: number }> };
  agreementAutoRenewal: { autoRenew: number; manual: number };
  rentByMonth: Array<{ month: string; paid: number; pending: number }>;
  electricityByMonth: Array<{ month: string; paid: number; billed: number; units: number }>;
  rentByCity: Array<{ city: string; paid: number }>;
  byClient: Array<{ clientId: number; clientName: string; rentPaid: number; electricityPaid: number }>;
  agreements: { byStatus: Record<string, number>; expiry: { d30: number; d60: number; d90: number } };
  discom: { byStatus: Record<string, number>; byServiceType: Array<{ type: string; count: number }> };
  totals: { stationsActive: number; rentPaidTotal: number; electricityPaidTotal: number; overdueTotal: number };
}

export const amStationOpsApi = {
  async dashboard(params: Record<string, unknown> = {}): Promise<AmDashboard> {
    return (await apiClient.get<ApiSuccess<AmDashboard>>('/am-station-ops/dashboard', { params })).data.data;
  },
  async monthly(months = 6, filters: Record<string, unknown> = {}): Promise<AmMonthlyPoint[]> {
    return (await apiClient.get<ApiSuccess<AmMonthlyPoint[]>>('/am-station-ops/analytics/monthly', { params: { months, ...filters } })).data.data;
  },
  async deep(params: Record<string, unknown> = {}): Promise<AmDeepAnalytics> {
    return (await apiClient.get<ApiSuccess<AmDeepAnalytics>>('/am-station-ops/analytics/deep', { params })).data.data;
  },
  async exportCsv(kind: 'rent' | 'electricity'): Promise<void> {
    const res = await apiClient.get(`/am-station-ops/export/${kind}`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data as Blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `am-${kind}-export.csv`;
    a.click();
    URL.revokeObjectURL(url);
  },
};
